export default __webpack_public_path__ + "static/media/lines.right-corner.9261f9d4.png";